var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-0",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('EmpWage',{attrs:{"aplyYyMm":_vm.$parent.$parent.sltDt,"fcltyNum":_vm.$parent.$parent.sltFcltyNum,"empPk":_vm.$parent.$parent.sltEmpPk}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }